import { hasExponent } from './hasExponent'
import { fromExponent } from './fromExponent'

export const numberToString = (num: number | string) => {
  const numStr = String(num)
  if (hasExponent(numStr)) {
    return fromExponent(num)
  }

  return numStr
}
